/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  CreatePropertyDefaultVendorRequest,
  GetApiPropertyDefaultVendorsList200,
  GetApiPropertyDefaultVendorsListParams,
  NotFoundErrorResponse,
  PropertyDefaultVendorApiResource,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiPropertyDefaultVendorsListResponse200 = {
  data: GetApiPropertyDefaultVendorsList200
  status: 200
}

export type getApiPropertyDefaultVendorsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyDefaultVendorsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyDefaultVendorsListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyDefaultVendorsListResponseSuccess = (getApiPropertyDefaultVendorsListResponse200) & {
  headers: Headers;
};
export type getApiPropertyDefaultVendorsListResponseError = (getApiPropertyDefaultVendorsListResponse401 | getApiPropertyDefaultVendorsListResponse403 | getApiPropertyDefaultVendorsListResponse404) & {
  headers: Headers;
};

export type getApiPropertyDefaultVendorsListResponse = (getApiPropertyDefaultVendorsListResponseSuccess | getApiPropertyDefaultVendorsListResponseError)

export const getGetApiPropertyDefaultVendorsListUrl = (propertyId: number,
    params?: GetApiPropertyDefaultVendorsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/default-vendors?${stringifiedParams}` : `/api/properties/${propertyId}/default-vendors`
}

export const getApiPropertyDefaultVendorsList = async (propertyId: number,
    params?: GetApiPropertyDefaultVendorsListParams, options?: RequestInit): Promise<getApiPropertyDefaultVendorsListResponse> => {
  
  return customFetch<getApiPropertyDefaultVendorsListResponse>(getGetApiPropertyDefaultVendorsListUrl(propertyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiPropertyDefaultVendorsCreateResponse201 = {
  data: PropertyDefaultVendorApiResource[]
  status: 201
}

export type postApiPropertyDefaultVendorsCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyDefaultVendorsCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyDefaultVendorsCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyDefaultVendorsCreateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiPropertyDefaultVendorsCreateResponseSuccess = (postApiPropertyDefaultVendorsCreateResponse201) & {
  headers: Headers;
};
export type postApiPropertyDefaultVendorsCreateResponseError = (postApiPropertyDefaultVendorsCreateResponse400 | postApiPropertyDefaultVendorsCreateResponse401 | postApiPropertyDefaultVendorsCreateResponse403 | postApiPropertyDefaultVendorsCreateResponse404) & {
  headers: Headers;
};

export type postApiPropertyDefaultVendorsCreateResponse = (postApiPropertyDefaultVendorsCreateResponseSuccess | postApiPropertyDefaultVendorsCreateResponseError)

export const getPostApiPropertyDefaultVendorsCreateUrl = (propertyId: number,) => {


  

  return `/api/properties/${propertyId}/default-vendors`
}

export const postApiPropertyDefaultVendorsCreate = async (propertyId: number,
    createPropertyDefaultVendorRequest: CreatePropertyDefaultVendorRequest, options?: RequestInit): Promise<postApiPropertyDefaultVendorsCreateResponse> => {
  
  return customFetch<postApiPropertyDefaultVendorsCreateResponse>(getPostApiPropertyDefaultVendorsCreateUrl(propertyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPropertyDefaultVendorRequest,)
  }
);}


export type deleteApiPropertyDefaultVendorsDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyDefaultVendorsDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyDefaultVendorsDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyDefaultVendorsDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyDefaultVendorsDeleteResponseSuccess = (deleteApiPropertyDefaultVendorsDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyDefaultVendorsDeleteResponseError = (deleteApiPropertyDefaultVendorsDeleteResponse401 | deleteApiPropertyDefaultVendorsDeleteResponse403 | deleteApiPropertyDefaultVendorsDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyDefaultVendorsDeleteResponse = (deleteApiPropertyDefaultVendorsDeleteResponseSuccess | deleteApiPropertyDefaultVendorsDeleteResponseError)

export const getDeleteApiPropertyDefaultVendorsDeleteUrl = (id: number,) => {


  

  return `/api/property-default-vendors/${id}`
}

export const deleteApiPropertyDefaultVendorsDelete = async (id: number, options?: RequestInit): Promise<deleteApiPropertyDefaultVendorsDeleteResponse> => {
  
  return customFetch<deleteApiPropertyDefaultVendorsDeleteResponse>(getDeleteApiPropertyDefaultVendorsDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


